import React from "react";
import { Emotion } from "../../types/types";
import { emotions } from "../../types/schemas";

export function CharacterModal({
    conversationName,
    emotion,
}: {
    conversationName: string;
    emotion: Emotion;
}) {
    const activeEmotion = emotion;

    return (
        <>
            {emotions[conversationName as keyof typeof emotions].map(
                (emotionType) => (
                    <div
                        key={emotionType}
                        className={`modal-character character-${conversationName} emotion-${emotionType.toLowerCase()} ${
                            activeEmotion === emotionType ? "active" : "hidden"
                        }`}
                    />
                ),
            )}
        </>
    );
}
